import { BodyText, SubheaderText } from '@/utils/global-fonts';
import { requiredValidationMessage } from '@/utils/validations';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Card from '../card/card-component';
import Input from '../react-hook-form-inputs/input/input-component';

const QuotePriceContainer = styled.div`
  display: flex;
  width: 100%;
`;

const MessageContainer = styled.div`
  display: flex;
  flex: 1;
`;

const PriceContainer = styled.div`
  display: flex;
  margin-right: 16px;
  min-width: 180px;
`;

const GreyLine = styled.div`
  display: flex;
  height: 1px;
  background-color: ${({ theme }) => theme.COLOR_GREY5};
`;

const StyledBodyText = styled(BodyText)`
  color: ${({ theme }) => theme.COLOR_TEXT};
`;

/**
 * Quote Price component.
 * @param {object} props The component props.
 * @param {string} props.heading The heading of the component.
 * @param {boolean} props.loading The loading state of the component.
 * @param {string} props.selectedSymbol The selected currency symbol.
 * @param {Function} props.onPriceChange The function to call when the price changes.
 * @param {Function} props.onMessageChange The function to call when the message changes.
 * @param {string} props.name The name of the input for React Hook Form. (Required)
 * @param {string} props.description The description of the component.
 * @param {Function} props.register The register function.
 * @returns {JSX.Element} The rendered Quote Price component.
 */
const QuotePrice = ({
  heading,
  description,
  loading,
  selectedSymbol,
  onPriceChange,
  onMessageChange,
  name,
  register,
}) => (
  <Card margin="8px 0px 8px 0px" borderRadius="4px">
    <SubheaderText {...register(`${name}.title`, heading)}>
      {heading}
    </SubheaderText>
    <GreyLine />
    {description && <StyledBodyText>{description}</StyledBodyText>}
    <QuotePriceContainer>
      <PriceContainer>
        <Input
          disabled={loading}
          label="Price"
          placeholder=""
          name={`${name}.price`}
          iconLeft={selectedSymbol}
          type="number"
          register={{
            required: requiredValidationMessage,
            onChange: onPriceChange,
          }}
        />
      </PriceContainer>
      <MessageContainer>
        <Input
          disabled={loading}
          label="Message"
          placeholder="Message"
          name={`${name}.value`}
          register={{
            onChange: onMessageChange,
          }}
        />
      </MessageContainer>
    </QuotePriceContainer>
  </Card>
);

QuotePrice.propTypes = {
  heading: PropTypes.string,
  loading: PropTypes.bool,
  selectedSymbol: PropTypes.string.isRequired,
  onPriceChange: PropTypes.func.isRequired,
  onMessageChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  register: PropTypes.func.isRequired,
};

QuotePrice.defaultProps = {
  heading: '',
  loading: false,
  onMessageChange: () => {},
  description: '',
};

export default QuotePrice;
